/**
 * YearEndSectionTitle
 *
 * 연말정산 페이지 전용 섹션 타이틀
 * - 가운데 정렬
 * - 양쪽 월계관 아이콘
 */

import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { IconLaurelWreath } from '@tabler/icons-react';

/**
 * @param {object} props
 * @param {string} props.title - 타이틀 텍스트
 * @param {React.ReactNode} [props.children] - 섹션 내부 컨텐츠
 * @param {object} [props.sx] - 추가 스타일
 */
const YearEndSectionTitle = ({ title, children, sx }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        borderBottom: '1px solid',
        borderColor: 'primary.main',
        ...sx,
      }}
    >
      {/* 타이틀 영역 */}
      <Box sx={{ py: 3, borderBottom: children ? '1px solid' : 'none', borderColor: 'primary.main' }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          spacing={2}
        >
          <IconLaurelWreath
            size={28}
            stroke={1.5}
            style={{ transform: 'scaleX(-1)' }}
            color={theme.palette.primary.main}
          />
          <Typography
            variant="h5"
            sx={{
              fontFamily: '"RIDIBatang", "Noto Serif KR", serif',
              fontWeight: 700,
              textAlign: 'center',
              letterSpacing: '0.05em',
            }}
          >
            {title}
          </Typography>
          <IconLaurelWreath
            size={28}
            stroke={1.5}
            color={theme.palette.primary.main}
          />
        </Stack>
      </Box>

      {/* 컨텐츠 영역 */}
      {children}
    </Box>
  );
};

export default YearEndSectionTitle;
